import Http from "../../system/utils/Http";

export const UPDATE_REGIONS = "overview/UPDATE_REGIONS";
export const UPDATE_MULTI_CENTER_REGIONS = 'overview/UPDATE_MULTI_CENTER_REGIONS';
export const UPDATE_DEAL_TYPES = "overview/UPDATE_DEAL_TYPES";
export const UPDATE_DEAL_STATUSES = "overview/UPDATE_DEAL_STATUSES";
export const UPDATE_AIRPORTS = "overview/UPDATE_AIRPORTS";
export const UPDATE_BOARD_TYPES = "overview/UPDATE_BOARD_TYPES";
export const UPDATE_FACILITIES = "overview/UPDATE_FACILITIES";
export const UPDATE_ROOM_TYPES = "overview/UPDATE_ROOM_TYPES";
export const UPDATE_HOTELS = "overview/UPDATE_HOTELS";
export const UPDATE_COUNTRIES = "overview/UPDATE_COUNTRIES";
export const UPDATE_CITIES = "overview/UPDATE_CITIES";
export const UPDATE_ENQUIRY_STATUSES = 'overview/UPDATE_ENQUIRY_STATUSES';
export const UPDATE_TAGS = 'overview/UPDATE_TAGS';
export const UPDATE_REVIEWS = 'overview/UPDATE_REVIEWS'

const initialState = {
  regions: [],
  multiCenterRegions: [],
  dealTypes: [],
  dealStatuses: [],
  airports: [],
  boardTypes: [],
  facilities: [],
  roomTypes: [],
  hotels: [],
  countries: [],
  cities: [],
  enquiryStatuses: [],
  tags: [],
  reviews: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_ENQUIRY_STATUSES: {
      return {
        ...state,
        enquiryStatuses: action.payload
      }
    }
    case UPDATE_CITIES: {
      return {
        ...state,
        cities: action.payload
      };
    }
    case UPDATE_COUNTRIES: {
      return {
        ...state,
        countries: action.payload
      };
    }
    case UPDATE_HOTELS: {
      return {
        ...state,
        hotels: action.payload
      };
    }
    case UPDATE_ROOM_TYPES: {
      return {
        ...state,
        roomTypes: action.payload
      };
    }
    case UPDATE_FACILITIES: {
      return {
        ...state,
        facilities: action.payload
      };
    }
    case UPDATE_BOARD_TYPES: {
      return {
        ...state,
        boardTypes: action.payload
      };
    }
    case UPDATE_AIRPORTS: {
      return {
        ...state,
        airports: action.payload
      };
    }
    case UPDATE_DEAL_STATUSES: {
      return {
        ...state,
        dealStatuses: action.payload
      };
    }
    case UPDATE_REVIEWS: {
      return {
        ...state,
        reviews: action.payload
      }
    }
    case UPDATE_DEAL_TYPES: {
      return {
        ...state,
        dealTypes: action.payload
      };
    }
    case UPDATE_MULTI_CENTER_REGIONS: {
      return {
        ...state,
        multiCenterRegions: action.payload
      }
    }
    case UPDATE_REGIONS: {
      return {
        ...state,
        regions: action.payload
      };
    }
    case UPDATE_TAGS: {
      return {
        ...state,
        tags: action.payload
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
};

export const getMultiCenterRegions = () => dispatch => {
  Http.get('/multi-center-regions')
    .then(res => {
      dispatch({
        type: UPDATE_MULTI_CENTER_REGIONS,
        payload: res.data.data
      });
    })
    .catch(err => {
      console.error(err);
    })
};

export const getRegions = () => dispatch => {
  Http.get("/regions")
    .then(res => {
      dispatch({
        type: UPDATE_REGIONS,
        payload: res.data.data
      });
    })
    .catch(err => {
      console.error(err);
    });
};

export const getDealTypes = () => dispatch => {
  Http.get("/deal-types")
    .then(res => {
      dispatch({
        type: UPDATE_DEAL_TYPES,
        payload: res.data.data
      });
    })
    .catch(err => {
      console.error(err);
    });
};

export const getDealStatuses = () => dispatch => {
  Http.get("/deal-statuses")
    .then(res => {
      dispatch({
        type: UPDATE_DEAL_STATUSES,
        payload: res.data.data
      });
    })
    .catch(err => {
      console.error(err);
    });
};

export const getReviews = () => dispatch => {
  Http.get('/reviews')
    .then(res => {
      dispatch({
        type: UPDATE_REVIEWS,
        payload: res.data.data
      });
    })
    .catch(err => {
      console.error(err)
    })
}

export const getAirports = () => dispatch => {
  Http.get("/airports")
    .then(res => {
      dispatch({
        type: UPDATE_AIRPORTS,
        payload: res.data.data
      });
    })
    .catch(err => {
      console.error(err);
    });
};

export const getBoardTypes = () => dispatch => {
  Http.get("/board-types")
    .then(res => {
      dispatch({
        type: UPDATE_BOARD_TYPES,
        payload: res.data.data
      });
    })
    .catch(err => {
      console.error(err);
    });
};

export const getFacilities = () => dispatch => {
  Http.get("/facilities")
    .then(res => {
      dispatch({
        type: UPDATE_FACILITIES,
        payload: res.data.data
      });
    })
    .catch(err => {
      console.error(err);
    });
};

export const getRoomTypes = () => dispatch => {
  Http.get("/rooms")
    .then(res => {
      dispatch({
        type: UPDATE_ROOM_TYPES,
        payload: res.data.data
      });
    })
    .catch(err => {
      console.error(err);
    });
};

export const getHotels = () => dispatch => {
  Http.get("/hotels")
    .then(res => {
      dispatch({
        type: UPDATE_HOTELS,
        payload: res.data.data
      });
    })
    .catch(err => {
      console.error(err);
    });
};

export const getCountries = () => dispatch => {
  console.log('IMHERE')
  Http.get("/countries")
    .then(res => {
      console.log('RESSSS', res)
      dispatch({
        type: UPDATE_COUNTRIES,
        payload: res.data.data
      });
    })
    .catch(err => {
      console.error(err);
    });
};

export const getCities = () => dispatch => {
  Http.get("/destinations")
    .then(res => {
      dispatch({
        type: UPDATE_CITIES,
        payload: res.data.data
      });
    })
    .catch(err => {
      console.error(err);
    });
};

export const getEnquiryStatuses = () => dispatch => {
  Http.get('/enquiry-statuses')
    .then(res => {
      dispatch({
        type: UPDATE_ENQUIRY_STATUSES,
        payload: res.data.data
      })
    })
    .catch(err => {
      console.error(err);
    })
};

export const getTags = () => dispatch => {
  Http.get('/tags')
    .then(res => {
      dispatch({
        type: UPDATE_TAGS,
        payload: res.data.data
      })
    })
    .catch(err => {
      console.error(err);
    })
}

export const getOverview = () => dispatch => {
  dispatch(getRoomTypes());
  dispatch(getFacilities());
  dispatch(getBoardTypes());
  dispatch(getAirports());
  dispatch(getDealStatuses());
  dispatch(getDealTypes());
  dispatch(getRegions());
  dispatch(getHotels());
  dispatch(getCountries());
  dispatch(getCities());
  dispatch(getTags());
  dispatch(getReviews());
};



// WEBPACK FOOTER //
// ./src/store/overview/index.js